/*=========================================================================================
  File Name: moduleCourseClassExamActions.js
  Description: CourseClassExam Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClassExam/AddCourseClassExam", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClassExam/GetAll")
        .then((response) => {
          commit('SET_CourseClassExams', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  searchCourseClassExam({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClassExam/searchCourseClassExam", search)
        .then((response) => {
          commit('SET_CourseClassExams', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  searchCourseClassExamByModel({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClassExam/searchCourseClassExamByModel", search)
        .then((response) => {
          commit('SET_CourseClassExams', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetCourseClassExamByCode(context, code) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClassExam/GetCourseClassExamByCode?code=" + code)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  AssignInstructorToMark(context, code) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClassExam/AssignInstructorToMark?code=" + code)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTraineeAvailableExam({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClassExam/getTraineeAvailableExam")
        .then((response) => {
          commit('SET_CourseClassExams', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTraineeAvailableExamByCourseClass({ commit }, data) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClassExam/getTraineeAvailableExamByCourseClass",
        {
          params: {
            traineeID: data.ID,
            courseClassID: data.CourseClassID
          }
        })
        .then((response) => {
          commit('SET_CourseClassExams', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTraineeAvailableExamByCourseClassForInstructor({ commit }, data) {

    return new Promise((resolve, reject) => {
      axios.get("api/CourseClassExam/getTraineeAvailableExamByCourseClassForInstructor",
        {
          params: {
            traineeID: data.ID,
            courseClassID: data.CourseClassID
          }
        })
        .then((response) => {
          commit('SET_CourseClassExams', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },


  GenerateQuestion({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClassExam/GenerateQuestion", item)
        .then((response) => {
          debugger
          response.data.forEach(element => {
            element.TimeOfQuestionInMinute = 0;
          });

          commit('SET_Question', response.data)

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  updateItem({ commit }, item) {
    commit('UPDATE_CourseClassExam', item)
    return new Promise((resolve, reject) => {
      axios.put("api/CourseClassExam/UpdateCourseClassExam?ID=" + item.ID, item)
        .then((response) => {
          debugger
          // commit('UPDATE_CourseClassExam', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  GetItemByID(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/CourseClassExam/GetCourseClassExam?ID=" + itemid)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CourseClassExam/DeleteCourseClassExam?ID=" + item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetQuestionPassStatistic({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClassExamQuestion/GetQuestionPassStatistic", search)
        .then((response) => {
          commit('SET_Question', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCourseClassExamPassStatistic(context, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClassExam/GetCourseClassExamPassStatistic", search)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetCoursePassStatistic(context, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/CourseClassExam/GetCoursePassStatistic", search)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
